var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgIconOpenPositions = function SvgIconOpenPositions(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5.75h-6A1.5 1.5 0 0 0 0 2.25v7a1.5 1.5 0 0 0 1.5 1.5h6A1.5 1.5 0 0 0 9 9.25v-7A1.5 1.5 0 0 0 7.5.75ZM1 2.25a.5.5 0 0 1 .5-.5H3v-.4a.1.1 0 0 1 .1-.1h2.8a.1.1 0 0 1 .1.1v.4h1.5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-7Z",
    fill: "#787878"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1.25h2.8A1.1 1.1 0 0 1 7 1.35v.8a1.1 1.1 0 0 1-1.1 1.1H3.1A1.1 1.1 0 0 1 2 2.15v-.8A1.1 1.1 0 0 1 3.1.25Zm0 1a.1.1 0 0 0-.1.1v.8a.1.1 0 0 0 .1.1h2.8a.1.1 0 0 0 .1-.1v-.8a.1.1 0 0 0-.1-.1H3.1Z",
    fill: "#787878"
  })));
};
export default SvgIconOpenPositions;